var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 47.5V47.25H30.25H5.75C4.92207 47.25 4.25 46.5779 4.25 45.75V10.75C4.25 9.92207 4.92207 9.25 5.75 9.25H58.25C59.0779 9.25 59.75 9.92207 59.75 10.75V45.75C59.75 46.5779 59.0779 47.25 58.25 47.25H33.75H33.5V47.5V54.5V54.75H33.75H40.75C41.5779 54.75 42.25 55.4221 42.25 56.25C42.25 57.0779 41.5779 57.75 40.75 57.75H23.25C22.4221 57.75 21.75 57.0779 21.75 56.25C21.75 55.4221 22.4221 54.75 23.25 54.75H30.25H30.5V54.5V47.5ZM56.5 44.25H56.75V44V12.5V12.25H56.5H7.5H7.25V12.5V44V44.25H7.5H56.5Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.6aa0ed39c00f5bfd0e8ecdf4c006e705.svg";
export { ForwardRef as ReactComponent };